module.exports = __webpack_public_path__ + "static/media/akash2.45263f48.png";